/**
 * @file 商业版设备指纹
 * @link https://dashboard.fingerprint.com/
 */

import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-vue-v3';
import md5 from 'md5';
import { useConfigStore } from '@/store/config';

export default () => {
  const configStore: any = useConfigStore();
  const { getData } = useVisitorData(
    { extendedResult: true },
    // Set to true to fetch data on mount
    { immediate: false }
  );
  const md5Key = md5('visitor_data');
  const visitorId = ref('');
  const visitorData = ref<any>({});
  const getVisitorData = async(update?: boolean) => {
    if (visitorId.value && !update) {
      return visitorData.value;
    }

    const visitorRes: any = await getData();

    if (visitorRes) {
      visitorData.value = visitorRes;
      visitorId.value = visitorRes?.visitorId || '';
      localStorage.setItem(md5Key, JSON.stringify({
        v: visitorRes.visitorId,
        r: visitorRes.requestId,
        t: Date.now()
      }));
      localStorage.removeItem('device-update');
    }

    return visitorRes || {};
  };

  /**
   * 获取设备指纹和请求ID
   *
   * @param update 是否强制更新
   * @returns
   */
  const getVisitorId = async(update?: boolean) => {
    // 取本地存储
    const localCache = localStorage.getItem(md5Key);

    if (localCache && !update) {
      try {
        const { v, r, t } = JSON.parse(localCache);

        if (Date.now() - t <= (configStore.config?.deviceTokenReportSeconds || 2592000)) {
          visitorData.value = { visitorId: v, requestId: r };
          visitorId.value = v;

          return { visitorId: v, requestId: r };
        }

        localStorage.removeItem(md5Key);
        return await getVisitorData(true);
      } catch (error) {
        return await getVisitorData();
      }
    }

    await getVisitorData(update);
  };

  return {
    getVisitorId,
    visitorData,
    visitorId,
    getData
  };
};
